module.exports = __webpack_public_path__ + "img/home page banner.abc97bc0.jpg";